import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerScale } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'empathy-viewer-icon-button',
  templateUrl: 'icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class EmpathyViewerIconButtonComponent {
  @Input() style: 'basic' | 'stroked' = 'basic';
  @Input() color: 'primary' | 'none' = 'primary';
  @Input() disabled = false;
  @Input() icon: IconDefinition;
  @Input() loading = false;
  @Input() loadingIcon = faSpinnerScale;
  @Input() size: 'large' | 'medium' | 'small' = 'medium';
  @Input() tooltip: string;

  @Output() clicked = new EventEmitter<void>();
}
